import { useMemo } from 'react';

import { useUserPermissionStatus } from 'selectors/user';
import { UserPermissions } from 'types/permissions';

export const useMapPermissions = (): UserPermissions => {
  const basePermissions = useUserPermissionStatus();

  return useMemo<UserPermissions>(
    () => ({
      ...basePermissions,
      hasPremiumCamPermissions: !!basePermissions?.hasPremiumCamPermissions,
    }),
    [basePermissions],
  );
};

export default useMapPermissions;
